import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDrivers } from "../../constants";

export const requestRestoreDriver = async (driverId: string): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesDrivers.Drivers, driverId, ApiRoutesDrivers.Restore)
  );
};
